export default __webpack_public_path__ + "static/media/telxl_logo_full_blue.7bb73284.svg";